'use strict';

var React = require('react');
var ReactDOM = require('react-dom');
var appTypes = require('../../types/appTypes');
var LabelParts = require('../common/LabelParts');
var assetsHelper = require('../../helper/assetsHelper');
var styleHelper = require('../../helper/styleHelper');
var textHelper = require('../../helper/util').Text;

var BreadCrumbs = React.createClass({

  _getItemArray: function () {
    return textHelper.delimitText(styleHelper.getText(this.props), textHelper.DM_COMMA);
  },

    render: function () {
    var backgroundStyle = {
      width: '100%',
      height: '100%'
    };

    var textArray = this._getItemArray();
    this.len = textArray.length;
    var separatorSrc = assetsHelper.getComponentAsset('commons/separator');
    styleHelper.StyleUtil(this.props).default(backgroundStyle).text();
    return (<div style={backgroundStyle}>
      {
        textArray.map(function (text, index) {
          var css = {
            display: 'inline-block',
            whiteSpace: 'nowrap'
          };
          if(index === textArray.length - 1){
            css.color = '#000';
          }
          var separatorStyle = {
            width: this.props.gap,
            display: 'inline-block',
            textAlign: 'center'
          };
          return (
            <div key={index} style={{display: 'inline-block'}}>
              <div ref={'text_' + index} style={css}>
                <label>{text}</label>
              </div>
              {
                index < this.len - 1 &&
                <div ref={'separator_' + index} style={separatorStyle}>
                  <img src={separatorSrc}/>
                </div>
              }
            </div>
          );
        }, this)
      }
    </div>);
  },

});

module.exports = BreadCrumbs;




// WEBPACK FOOTER //
// ./src/views/Components/BreadCrumbs.jsx